import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { GNB_ITEMS, MY_PAGE_PATH } from '@/shared/config';

interface SiteHeaderMenuProps {
  readonly id: string;
  readonly isSignedIn: boolean;
  readonly onSignOut: () => void;
  /** 링크를 누르면 메뉴를 닫는다. */
  readonly onNavigate: () => void;
}

const UTILITY_LINK_CLASS = 'text-foreground/75 transition-colors hover:text-foreground';

/** 좁은 화면의 펼침 메뉴 — 헤더 아래 화면을 덮고, GNB 를 큰 글자로, 회원 메뉴를 그 아래에 둔다. */
export const SiteHeaderMenu = ({
  id,
  isSignedIn,
  onSignOut,
  onNavigate,
}: SiteHeaderMenuProps): ReactElement => (
  <div
    id={id}
    className="pointer-events-auto absolute inset-x-0 top-full z-40 h-[calc(100dvh-4rem)] overflow-y-auto sm:h-[calc(100dvh-5rem)] bg-background px-4 pt-4 pb-8 sm:px-6 xl:hidden"
  >
    <nav aria-label="모바일 메뉴">
      <ul className="flex flex-col">
        {GNB_ITEMS.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              onClick={onNavigate}
              className="block py-2 text-2xl font-light tracking-[-0.02em]"
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>

      <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 border-t border-foreground/10 pt-5 text-sm">
        {isSignedIn ? (
          <>
            <li>
              <Link to={MY_PAGE_PATH} onClick={onNavigate} className={UTILITY_LINK_CLASS}>
                마이페이지
              </Link>
            </li>
            <li>
              <button
                type="button"
                onClick={() => {
                  onNavigate();
                  onSignOut();
                }}
                className={UTILITY_LINK_CLASS}
              >
                로그아웃
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to="/sign-in" onClick={onNavigate} className={UTILITY_LINK_CLASS}>
                로그인
              </Link>
            </li>
            <li>
              <Link to="/sign-up" onClick={onNavigate} className={UTILITY_LINK_CLASS}>
                회원가입
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  </div>
);
